// Accordion expand/collapse functionality
export function initOffCanvas() {
    const mobileToggle = document.getElementById('mobile-toggle');
    const collapsedMenuIcon = mobileToggle?.querySelector('.menu-collapsed');
    const expandedMenuIcon = mobileToggle?.querySelector('.menu-expanded');

    if (mobileToggle) {
        const offcanvasId = mobileToggle.getAttribute('data-offcanvas');
        const offcanvasElement = offcanvasId ? document.getElementById(offcanvasId) : null;

        // Toggle offcanvas on button click
        mobileToggle.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent immediate closing
            // console.log('Mobile toggle clicked');
            if (offcanvasElement) {

                // Hide search input if open
                const searchContainer = document.getElementById('search-input-container');
                if (searchContainer && !searchContainer.classList.contains('hidden')) {
                    searchContainer.classList.add('hidden');
                }
                const isOpen = !offcanvasElement.classList.contains('translate-x-[200%]');

                if (isOpen) {
                    offcanvasElement.classList.add('translate-x-[200%]');
                    collapsedMenuIcon?.classList.remove('hidden');
                    expandedMenuIcon?.classList.add('hidden');

                    setTimeout(() => {
                        offcanvasElement.classList.add('hidden');
                    }, 300); // Match the duration-300 class
                } else {
                    offcanvasElement.classList.remove('translate-x-[200%]');
                    offcanvasElement.classList.remove('hidden');
                    collapsedMenuIcon?.classList.add('hidden');
                    expandedMenuIcon?.classList.remove('hidden');
                }
            }
        });

        // Close offcanvas when clicking outside
        if (offcanvasElement) {
            document.addEventListener('click', (e) => {
                const isOffcanvasOpen = !offcanvasElement.classList.contains('translate-x-[200%]');
                const clickedInsideOffcanvas = offcanvasElement.contains(e.target as Node);
                const clickedToggleButton = mobileToggle.contains(e.target as Node);

                if (isOffcanvasOpen && !clickedInsideOffcanvas && !clickedToggleButton) {
                    offcanvasElement.classList.add('translate-x-[200%]');
                    collapsedMenuIcon?.classList.remove('hidden');
                    expandedMenuIcon?.classList.add('hidden');
                }
            });

            // Close on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    const isOffcanvasOpen = !offcanvasElement.classList.contains('translate-x-[200%]');
                    if (isOffcanvasOpen) {
                        offcanvasElement.classList.add('translate-x-[200%]');
                        collapsedMenuIcon?.classList.remove('hidden');
                        expandedMenuIcon?.classList.add('hidden');
                    }
                }
            });
        }
    }

}
